export default "__VITE_ASSET__86021fbf__"